<div class="banner-wrapper">
  <inbox-ai-background-gradient>
    <div class="content">
      <glxy-avatar
        class="avatar"
        [svgIcon]="VENDASTA_AI_AVATAR_SVG_ICON"
        [width]="avatarWidth"
        [borderColor]="avatarBorderColor"
      ></glxy-avatar>

      <div class="text-block">
        <div class="ai-support-title">{{ 'INBOX.CONTACT_ASSISTANT.SUPPORT_AI_TITLE' | translate }}</div>
        <div class="ai-support-description">
          {{ 'INBOX.CONTACT_ASSISTANT.SUPPORT_AI_BANNER_DESCRIPTION' | translate }}
        </div>
        <button mat-flat-button class="chat-button" (click)="openInboxAI()">
          <div class="button-content">
            {{ 'INBOX.CONTACT_ASSISTANT.SUPPORT_AI_BUTTON_TEXT' | translate
            }}<mat-icon class="right-arrow">arrow_forward_ios</mat-icon>
          </div>
        </button>
      </div>
    </div>
  </inbox-ai-background-gradient>
</div>
